import { GenIcon } from "react-icons";

function File(props) {
  return GenIcon({
    tag: "svg",
    attr: {
      viewBox: "0 0 16 16",
    },
    child: [
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d:
            "M14.0004 7.59079C14.0009 6.54553 14.0013 5.81886 13.7078 5.16531C13.4143 4.51175 12.8709 4.02926 12.0893 3.33523L11.4552 2.7716C10.7904 2.18012 10.3286 1.76921 9.7544 1.55091C9.18024 1.33262 8.56204 1.33289 7.67218 1.33328L7.28661 1.33332C6.38387 1.33329 5.63946 1.33327 5.05028 1.41249C4.43173 1.49565 3.88545 1.67696 3.44804 2.11437C3.01064 2.55177 2.82932 3.09806 2.74616 3.71661C2.66695 4.30577 2.66697 5.05016 2.66699 5.95289V10.047C2.66697 10.9498 2.66695 11.6942 2.74616 12.2834C2.82932 12.9019 3.01064 13.4482 3.44804 13.8856C3.88545 14.323 4.43173 14.5043 5.05028 14.5875C5.63946 14.6667 6.38387 14.6667 7.28661 14.6667H9.38069C10.2834 14.6667 11.0279 14.6667 11.617 14.5875C12.2356 14.5043 12.7819 14.323 13.2193 13.8856C13.6567 13.4482 13.838 12.9019 13.9212 12.2834C14.0004 11.6942 14.0003 10.9498 14.0003 10.047L14.0004 7.59079ZM12.6624 6.94629C12.6662 7.16421 12.667 7.42101 12.667 7.72834V9.99999C12.667 10.9616 12.6656 11.6158 12.5997 12.1057C12.5364 12.5764 12.4248 12.7944 12.2765 12.9428C12.1281 13.0912 11.9101 13.2028 11.4394 13.266C10.9495 13.3319 10.2953 13.3333 9.33366 13.3333H7.33366C6.372 13.3333 5.71783 13.3319 5.22795 13.266C4.75725 13.2028 4.53923 13.0912 4.39085 12.9428C4.24247 12.7944 4.13089 12.5764 4.0676 12.1057C4.00174 11.6158 4.00033 10.9616 4.00033 9.99998L4.00033 5.99999C4.00033 5.03833 4.00174 4.38415 4.06761 3.89427C4.13089 3.42357 4.24247 3.20556 4.39085 3.05718C4.53923 2.9088 4.75725 2.79721 5.22795 2.73393C5.71783 2.66807 6.372 2.66665 7.33366 2.66665H7.55593C8.064 2.66665 8.40967 2.669 8.667 2.68501L8.66699 3.58785C8.66696 4.13454 8.66694 4.60792 8.71657 4.99012C8.76991 5.40095 8.8898 5.79535 9.19523 6.12729C9.50067 6.45924 9.88375 6.61146 10.2887 6.69874C10.6655 6.77994 11.1372 6.81923 11.682 6.86459L12.6624 6.94629ZM12.4292 5.5889C12.2515 5.27767 11.9198 4.96851 11.1007 4.24043L10.6563 3.84541C10.3836 3.60303 10.1727 3.41718 10.0003 3.27279V3.54623C10.0003 4.14654 10.0016 4.5323 10.0388 4.81842C10.0735 5.08559 10.1297 5.1737 10.1764 5.22448C10.2231 5.27526 10.3063 5.33858 10.5696 5.39534C10.8517 5.45612 11.236 5.48947 11.8342 5.53932L12.4292 5.5889Z",
        },
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d:
            "M5.33366 10.3333C5.33366 9.96506 5.63214 9.66659 6.00033 9.66659H10.667C11.0352 9.66659 11.3337 9.96506 11.3337 10.3333C11.3337 10.7014 11.0352 10.9999 10.667 10.9999H6.00033C5.63214 10.9999 5.33366 10.7014 5.33366 10.3333Z",
        },
      },
      {
        tag: "path",
        attr: {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d:
            "M5.33366 7.66659C5.33366 7.2984 5.63214 6.99992 6.00033 6.99992H7.83699C8.20518 6.99992 8.50366 7.2984 8.50366 7.66659C8.50366 8.03478 8.20518 8.33325 7.83699 8.33325H6.00033C5.63214 8.33325 5.33366 8.03478 5.33366 7.66659Z",
        },
      },
    ],
  })(props);
}

export default File;
